import React from 'react';
import { Home } from 'react-feather';

function RentalIncomeGrid({ formData, onDataChange }) {
  return (
    <div className="form-section">
      <div className="content-box-header">
        <h2><Home size={20} className="icon-orange" /> Rental Real Estate</h2>
      </div>

      <div className="dependent-card">
        <div className="form-group">
          <label style={{ fontWeight: 600, color: '#553e33ff' }}>Net Rental Income (Schedule 1, Line 5)</label>
          <p style={{ fontSize: '0.9rem', color: '#8b7364ff', marginBottom: '0.75rem' }}>
            Enter the total Net Income (or Loss) from all rental properties.
          </p>
          <div className="input-with-prefix">
            <span className="prefix">$</span>
            <input 
              type="number" 
              name="manualRentalIncome" 
              value={formData?.manualRentalIncome ?? ''} 
              onChange={onDataChange} 
              placeholder="0" 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RentalIncomeGrid;